// @ts-check

const v4blocks = document.querySelector('body[class*="template-v4-blocks"]');

if (v4blocks) {
  const coverTitle = v4blocks.querySelector(
    ".iop-hero .wp-block-cover__inner-container h1",
  );

  if (coverTitle) {
    const computedStyle = getComputedStyle(coverTitle);
    const color = computedStyle.color;

    const header = /** @type {HTMLElement} */ (
      v4blocks.querySelector(".header")
    );

    if (header) {
      header.classList.add("no-transition");
      header.style.setProperty("--header--initial--color", color);
      // remove the no-transition class on the next frame to prevent transitions or flashing
      requestAnimationFrame(() => {
        header.classList.remove("no-transition");
      });
    }
  }
}
